// const Ajv = require('ajv')

import Ajv from 'ajv/dist/2020.js'

// Default ajv instance for strict validation
export default new Ajv({ strict: false })

// Forgiving ajv instance that removes extra properties instead of failing Used for paste operations where dev environment may have newer schema properties
export const ajvForgiving = new Ajv({ strict: false, removeAdditional: true })
